import { render, staticRenderFns } from "./AppSelection.vue?vue&type=template&id=0fa72e22&scoped=true"
import script from "./AppSelection.vue?vue&type=script&lang=js"
export * from "./AppSelection.vue?vue&type=script&lang=js"
import style0 from "./AppSelection.vue?vue&type=style&index=0&id=0fa72e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa72e22",
  null
  
)

export default component.exports